import type { ApolloError } from '@apollo/client';
import React from 'react';

import Loader from '../../../../../../../../../common/Loader';
import { getConflictComponents } from '../../utils/getRows/conflicts';

export type AdStatusConflictsProps = {
  isLoading?: boolean;
  adsStatusErrors?: Record<string, string[]> | null;
  calculatedCreativeDataFetchError?: ApolloError;
};

const AdStatusConflicts = ({ isLoading, adsStatusErrors }: AdStatusConflictsProps): React.JSX.Element | null => {
  if (isLoading) return <Loader />;

  return (
    <>
      {adsStatusErrors &&
        getConflictComponents(
          Object.keys(adsStatusErrors).map((conflictKey) => ({
            message: conflictKey,
            conflictIds: adsStatusErrors[conflictKey],
            isShown: !!adsStatusErrors,
          }))
        )}
    </>
  );
};

export default AdStatusConflicts;
